import { Airframe } from "../../../../types/airframe";
import { Component } from "../../../../types/component";
import type { DisplayPreferences } from "../../../../hooks/useTenantDisplayPreferences";
import { AirframeGridTable } from "./AirframeGridTable";

type Props = {
  airframes: Airframe[];
  components: Component[];
  displayPreferences: DisplayPreferences;
  getInstalledComponentsForAirframe: (airframe: Airframe) => Component[];
  onAttach: (p: Airframe) => void;
  onEdit: (p: Airframe) => void;
  onDelete: (p: Airframe) => void;
  onMiniPack: (p: Airframe) => void;
  onReplace: (p: Airframe, c: Component) => void;
  onDetach: (componentId: string, airframeId?: string, slotId?: string) => void;
};

export function AirframeGridView({ airframes, displayPreferences, ...actions }: Props) {
  return <AirframeGridTable airframes={airframes} displayPreferences={displayPreferences} {...actions} />;
}
